var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#303c42;stroke-linecap:round;stroke-linejoin:round}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Barrel"},[React.createElement("ellipse",{"className":"cls-1","cx":"11","cy":"5","rx":"9.5","ry":"4.5","key":0}),React.createElement("ellipse",{"className":"cls-1","cx":"15.5","cy":"5","rx":"1","ry":".5","key":1}),React.createElement("path",{"className":"cls-1","d":"M.92 21.44C3.06 22.68 6.77 23.5 11 23.5s7.94-.82 10.08-2.06m.39-8.25c-2.05 1.38-6 2.31-10.47 2.31S2.58 14.57.53 13.19","key":2}),React.createElement("path",{"className":"cls-1","d":"M1.5 5s-1 3.07-1 10a35.62 35.62 0 0 0 1.35 10.78c.7 2.11 4.52 3.72 9.14 3.72s8.44-1.61 9.14-3.72A35.62 35.62 0 0 0 21.5 15c0-6.93-1-10-1-10","key":3})]))]);
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 22 30"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
